export default {"src":"/blog/_next/static/media/chev_right.ed28207d.svg","height":10,"width":18};